// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"359b1cbc","396":"ceeea0e6","455":"47a7ed00","817":"8cb2deb4","977":"1b576c13"}[chunkId] + ".chunk.js";
};